// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1cCd4","modalFooterButton":"ModalNotes_modalFooterButton__23Q-8"};